import { render, staticRenderFns } from "./SetupOverviewGroupSync.vue?vue&type=template&id=47dee957&scoped=true"
import script from "./SetupOverviewGroupSync.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewGroupSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dee957",
  null
  
)

export default component.exports